import useSWR from 'swr'
import { datoRequest } from '@/lib/datocms/server'
import { SubCategoryBelongsToInternationalDocument } from '@/lib/types/datocms/graphql/generated'

export function useIsInternationalSubcategory(subcategoryId: string | undefined) {
	const { data, error, isLoading } = useSWR(
		subcategoryId ? ['isInternationalSubcategory', subcategoryId] : null,
		async () => {
			if (!subcategoryId) return false

			const { productSubCategory } = await datoRequest(SubCategoryBelongsToInternationalDocument, {
				subcategoryId,
			})

			return (
				productSubCategory?._allReferencingCategories?.length &&
				productSubCategory?._allReferencingCategories?.length > 0
			)
		}
	)

	return {
		isInternational: !!data,
		isLoading,
		error,
	}
}
